import { type Theme } from '@mui/material';
import { Typography, useMediaQuery } from '@mui/material';
import { Navigate } from 'react-router-dom';

import { NavigationMenu } from './Layout/components/NavigationMenu';

export const Index = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'), { noSsr: true });

  // Redirect to default desktop route
  if (!isMobile) return <Navigate to="/activity" />;

  return (
    <div>
      <Typography padding={0.5} variant="h2">
        Menu
      </Typography>
      <NavigationMenu />
    </div>
  );
};
